var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.875 61.9951C3.875 77.4108 9.99887 92.1951 20.8994 103.096C31.8 113.996 46.5843 120.12 62 120.12C77.4157 120.12 92.2 113.996 103.101 103.096C114.001 92.1951 120.125 77.4108 120.125 61.9951C120.125 46.5794 114.001 31.7951 103.101 20.8945C92.2 9.99398 77.4157 3.87012 62 3.87012C46.5843 3.87012 31.8 9.99398 20.8994 20.8945C9.99887 31.7951 3.875 46.5794 3.875 61.9951Z",
    fill: "#22C55E",
    stroke: "#22C55E",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31 68.3192L43.6583 86.2837C44.1385 87.0009 44.783 87.5931 45.5382 88.0109C46.2934 88.4288 47.1375 88.6602 48.0002 88.686C48.863 88.7118 49.7194 88.5311 50.4982 88.1591C51.277 87.7871 51.9557 87.2344 52.4778 86.5471L93 35.2783",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.25f6868cd911f76083c9c77a89ad9bd0.svg";
export { ForwardRef as ReactComponent };